import { Box, Paper, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useNavigate, useParams } from "react-router-dom";
import DOMPurify from "dompurify";
import { Documento, ISdocumento } from "../../../types/processo/Documento";
import { useEffect, useRef, useState } from "react";
import { useGetDocumentoQuery } from "../createDocumento/documentoApiSlice";
import configUrls from "../../../config/configUrls";
import { DocumentoInternoViewMenu } from "./DocumentoInternoViewMenu";
import CabecalhoDocumentos from "./CabecalhoDocumentos";
import { useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import PrintFullContentButton from "../../../components/formControls/PrintFullContentButton";

export const DocumentoView = () => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [documento, setDocumento] = useState<Documento>(ISdocumento);
  const { id } = useParams();

  const { processoSelecionado } = useSelector(
    (state: RootState) => state.processoSelecionado
  );
  useEffect(() => {
    if (!processoSelecionado) {
      alert("Nenhum processo selecionado");
      window.location.href = configUrls.PROCESSO_LIST_RT;
    }
  }, [processoSelecionado]);

  const { data, isFetching, error } = useGetDocumentoQuery(id || "");
  useEffect(() => {
    if (data) {
      setDocumento(data);
    } else if (error) {
      enqueueSnackbar("Registro não encontrado!", { variant: "error" });
      window.location.href = configUrls.PROCESSO_LIST_RT;
    } else if (isFetching) {
      enqueueSnackbar("Buscando registro...", { variant: "info" });
    } else {
      enqueueSnackbar("Registro não encontrado!", { variant: "error" });
      window.location.href = configUrls.PROCESSO_LIST_RT;
    }
  }, [data, error, isFetching, enqueueSnackbar]);





  const bodyRef = useRef<HTMLDivElement | null>(null);  
  
  
  const conteudoParaImpressao = 
  `
    <div>       
      <div style="font-size: 1.0rem; text-align: justify; padding: 10px">>
          ${bodyRef.current ? bodyRef.current.innerHTML : ''}     
      </div>    
    </div>    


  `;

  return (
    <Box sx={{ padding: 1 }}>
      <Box p={1}>
        <DocumentoInternoViewMenu documento={documento.id} documentoData={documento} />
      </Box>

        <Box p={1}>
     
      </Box>

      <Paper
        elevation={3}
        sx={{
          padding: 2,
          backgroundColor: "#f5f5f5", // Cor de fundo cinza claro
          borderRadius: 2, // Bordas arredondadas
          boxShadow: 3, // Sombra para destacar o papel
          overflow: "hidden", // Evita que o conteúdo transborde
          wordWrap: "break-word", // Quebra palavras longas para evitar transbordamento
          display: "flex",
          flexDirection: "column", // Empilha o cabeçalho e o conteúdo
          alignItems: "flex-start", // Alinha ao início (esquerda)
          width: "100%",
          maxWidth: "100%",
        }}
          
      >
        <Box
          id="cabecalho"
          sx={{
            display: "flex",
            width: "100%",
          }}
        
        >
          <CabecalhoDocumentos documento={documento} />
        </Box>

        <Box id="conteudo" mt={2}>
          <Typography
            variant="subtitle1"
            component="div"
            textAlign="justify"
            style={{ fontSize: "1.0rem" }}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(documento.conteudo),
            }}
             ref={bodyRef} // Atribuindo a referência para o cabeçalho
          />
        </Box>
      </Paper>
    </Box>
  );
};
